var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1236_3812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6972 16.7345C11.6317 16.7345 12.392 16.0265 12.392 15.1561C12.392 14.585 11.6005 13.2566 10.6998 12.062C9.7968 13.2663 9.00244 14.5982 9.00244 15.1561C9.00244 16.0265 9.7627 16.7345 10.6972 16.7345Z",
    fill: "url(#paint0_linear_1236_3812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5469 3.57422H21.1523V6.21094C21.1523 6.69609 20.7586 7.08984 20.2734 7.08984H9.72656C9.24141 7.08984 8.84766 6.69609 8.84766 6.21094V3.57422H4.45312C3.96797 3.57422 3.57422 3.96797 3.57422 4.45312V29.1211C3.57422 29.6062 3.96797 30 4.45312 30H25.5469C26.032 30 26.4258 29.6062 26.4258 29.1211V4.45312C26.4258 3.96797 26.032 3.57422 25.5469 3.57422ZM8.68389 11.8665C9.345 10.8952 9.99744 10.1178 10.0249 10.0852C10.375 9.66914 11.0156 9.6682 11.3673 10.0822C11.3948 10.1146 12.0482 10.8861 12.71 11.855C13.6789 13.2735 14.15 14.3533 14.15 15.1561C14.15 16.9957 12.6011 18.4923 10.6973 18.4923C8.79357 18.4923 7.24477 16.9957 7.24477 15.1561C7.24477 14.3654 7.71551 13.2893 8.68389 11.8665ZM22.0312 25.5469H7.96875C7.48359 25.5469 7.08984 25.1531 7.08984 24.668C7.08984 24.1828 7.48359 23.7891 7.96875 23.7891H22.0312C22.5164 23.7891 22.9102 24.1828 22.9102 24.668C22.9102 25.1531 22.5164 25.5469 22.0312 25.5469ZM22.0312 22.0312H7.96875C7.48359 22.0312 7.08984 21.6375 7.08984 21.1523C7.08984 20.6672 7.48359 20.2734 7.96875 20.2734H22.0312C22.5164 20.2734 22.9102 20.6672 22.9102 21.1523C22.9102 21.6375 22.5164 22.0312 22.0312 22.0312ZM22.0312 18.5156H16.7578C16.2727 18.5156 15.8789 18.1219 15.8789 17.6367C15.8789 17.1516 16.2727 16.7578 16.7578 16.7578H22.0312C22.5164 16.7578 22.9102 17.1516 22.9102 17.6367C22.9102 18.1219 22.5164 18.5156 22.0312 18.5156ZM22.0312 15H16.7578C16.2727 15 15.8789 14.6062 15.8789 14.1211C15.8789 13.6359 16.2727 13.2422 16.7578 13.2422H22.0312C22.5164 13.2422 22.9102 13.6359 22.9102 14.1211C22.9102 14.6062 22.5164 15 22.0312 15ZM22.0312 11.4844H16.7578C16.2727 11.4844 15.8789 11.0906 15.8789 10.6055C15.8789 10.1203 16.2727 9.72656 16.7578 9.72656H22.0312C22.5164 9.72656 22.9102 10.1203 22.9102 10.6055C22.9102 11.0906 22.5164 11.4844 22.0312 11.4844Z",
    fill: "url(#paint1_linear_1236_3812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3945 1.81641H18.2467L17.6074 0.496289C17.4609 0.192773 17.1533 0 16.8164 0H13.2422C12.9053 0 12.5977 0.192773 12.4512 0.496289L11.8119 1.81641H10.6055V5.33203H19.3945V1.81641Z",
    fill: "url(#paint2_linear_1236_3812)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1236_3812",
    x1: 9.04976,
    y1: 15.8,
    x2: 12.392,
    y2: 15.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1236_3812",
    x1: 3.89321,
    y1: 24.7148,
    x2: 26.4258,
    y2: 24.7148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1236_3812",
    x1: 10.7282,
    y1: 4.26562,
    x2: 19.3945,
    y2: 4.26562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E854"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1236_3812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIc);
export default __webpack_public_path__ + "static/media/report_ic.1e77422717bbb01c6f2b7af4717dcd6c.svg";
export { ForwardRef as ReactComponent };